import type { CheckboxFilterTileProps } from './CheckboxFilterTile';
import type { DateRangeFilterTileProps } from './DateRangeFilterTile';

export const isDateRangeFilterAccordionType = (
  filter: DateRangeFilterTileProps | CheckboxFilterTileProps
): filter is DateRangeFilterTileProps => {
  return 'setValues' in filter;
};
